import React from "react";
import { Redirect } from "react-router-dom";
import Dashboard from "../pages/Employee/Dashboard/component";
import Home from "../pages/Home/component";
import Survey from "../pages/Survey/Survey-CRR";
import SurveyResponse from "../pages/Admin/Surveys/SurveyResponse/component";
import OrganizationView from "../pages/SuperAdmin/OrganizationView/OrganizationView";
import NotFound from "../pages/NotFound/component";
import PreAssessmentHome from "../pages/Admin/PreAssesment/Home";
import Unauthorised from "../pages/Unauthorised/Unauthorised";
import ControlLibrary from "../pages/Control_library/LinkList/ControlLibrary";
import SuperAdminHome from "../pages/SuperAdmin/SuperAdminHome";
import AdminLayout from "../pages/Admin/AdminLayout";
import StateAdminLayout from "../pages/StateDOTAdmin/StateAdminPortal/StateAdminLayout";
import SurveyHome from "../pages/Survey/SurveyHome";
import IncidentResponseLayout from "../pages/IncidentResponse/IncidentResponseLayout";

const userRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/survey", component: SurveyHome },
  { path: "/employee-control-library", component: ControlLibrary },
  // admin routes
  { path: "/admin-survey-list", component: AdminLayout },
  { path: "/admin-survey-questionnaire", component: SurveyResponse },
  { path: "/user-management", component: AdminLayout },
  { path: "/admin-organization-profile", component: AdminLayout },
  { path: "/admin-dashboard", component: AdminLayout },
  { path: "/control-library", component: AdminLayout },

  // incident response playbooks (single mini-router mounted for all sub-paths;
  // userRoutes are matched with `exact`, so every depth is enumerated here)
  {
    path: [
      "/playbooks",
      "/playbooks/dashboard",
      "/playbooks/sessions",
      "/playbooks/reports",
      "/playbooks/administration",
      "/playbooks/route",
      "/playbooks/scenario/:id",
      "/playbooks/scenario/:id/gate",
      "/playbooks/run/:sessionId",
    ],
    component: IncidentResponseLayout,
  },

  //pre-assessment
  { path: "/pre-assessments", component: PreAssessmentHome },

  //CATT Routes
  // { path: "/survey-catt", component: SurveyCATT },

  // super admin routes
  {
    path: "/super-admin-organisation-profile/:id/:email",
    component: OrganizationView,
  },
  { path: "/super-admin", component: SuperAdminHome },
  {
    path: "/super-admin-member-organizations-list/:stateid",
    component: SuperAdminHome,
  },
  { path: "/super-admin-membership-portal", component: SuperAdminHome },
  //membership portal routes

  { path: "/state-admin-dashboard", component: StateAdminLayout },
  { path: "/state-admin-organizations", component: StateAdminLayout },

  // this route should be at the end of all other routes

  { path: "/", exact: true, component: () => <Redirect to="/sign-in" /> },
  { path: "*", exact: true, component: () => <NotFound /> },
];

const authRoutes = [
  { path: "/sign-in", component: Home },
  { path: "/sign-up", component: Home },
  { path: "/forgot-password", component: Home },
  { path: "/magic-link-sent", component: Home },
  { path: "/verify-token", component: Home },
  { path: "/password-reset/:token", component: Home },
  { path: "/unauthorized", component: Unauthorised },
];

export { authRoutes, userRoutes };
